import React from 'react'
import Contact from '../contact/contact'
// import Experience from '../experience/experience'
import Footer from '../footer/footer'
import Hero from '../hero/hero'
import Projects from '../projects/projects'
import Skills from '../skills/skills'
import { Container, Hidden, useMediaQuery } from '@mui/material';
import SocialLinks from '../../common/social/social'
import Header from '../header/header'
import About from '../about/about'
import Experience from '../experience/experience'
import { CONSTANTS } from '../../../models/constants'
import Aurora from '../../common/bits/aurora';
import ProfileCard from '../../common/bits/profile-card/profile-card'
import Gallery from '../gallery/gallery'

export default function Home() {
        const handleShow = (i) =>  {
            console.log(i, document.getElementById(i));
            document.getElementById(i).scrollIntoView({ behavior: 'smooth' });
        };
        const prefersDarkMode = useMediaQuery('(prefers-color-scheme: dark)');
    return (
      <div className="">
        {/* <div className={"ui-position--fixed ui-width--full ui-glassmoprhic-bg ui-border--r0 ui-z-index--9 " + (prefersDarkMode ? "ui-color-bg--grey-90" : " ui-color-bg--grey-90 ")}> */}
          <Header handleShow={(value) => handleShow(value)}></Header>
        {/* </div> */}
        <div id={CONSTANTS.SECTIONS.HOME.id} className="ui-padding--36"></div>
        <Hero></Hero>
        <div id={CONSTANTS.SECTIONS.ABOUT.id} className="ui-padding--36"></div>
        <About></About>
        <div id={CONSTANTS.SECTIONS.PROJECT.id} className="ui-padding--36"></div>
        <Projects></Projects>
        <div id={CONSTANTS.SECTIONS.SKILLS.id} className="ui-padding--36"></div>
        <Skills></Skills>
        <div id={CONSTANTS.SECTIONS.EXPERIENCE.id} className="ui-padding--36"></div>
        <Experience></Experience>
        <div id={CONSTANTS.SECTIONS.CONTACT.id} className="ui-padding--36"></div>
        <Contact></Contact>
        <Container maxWidth="lg">
          <Hidden mdUp>
            <SocialLinks displayType="horizontal"></SocialLinks>
          </Hidden>
        </Container>
        <div id={CONSTANTS.SECTIONS.GALLERY.id} className="ui-padding--36 "></div>
          <Gallery />
       
        <div className="ui-padding--36"></div>
        <div className="">
          <Footer></Footer>
        </div>
      </div>
    );
}
